import React from 'react';

import style from './AnalystOneYearPriceTarget.module.css';
import UpsideBadge from '../UpsideBadge/UpsideBadge';
import AnalystRecommendations from '../AnalystRecommendations/AnalystRecommendations';

const AnalystOneYearPriceTarget = ({ stock, price_target_summary, price }) => {
  if (!price_target_summary || !price_target_summary.avg) {
    return null;
  }

  const price_target = parseFloat(price_target_summary.avg);
  const change = ((price_target - price) / price) * 100;

  return (
    <div className={style.container}>
      <span className={style.price}>${price_target.toFixed(2)}</span>
      <h3 className={style.headline}>Target Price by Analysts</h3>
      <UpsideBadge change={change.toFixed(1)} />

      <AnalystRecommendations stock={stock} />
      <a href={`/stocks/${stock.symbol.toLowerCase()}/target-price`} className={style.smallLink}>
        <span>{stock.simple_name} Target Price Details</span>
        <img src="/react/phosphor/caret-right-bold.svg" alt="Target Price" width="12" height="12" />
      </a>
    </div>
  );
};

export default AnalystOneYearPriceTarget;

